import React from "react";
import { motion } from "framer-motion";

export const Features = (props) => {
  return (
    <motion.section
      id="features"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <div className="section-header-modern">
          <span className="section-tag"><i className="fa fa-star"></i> Our Strengths</span>
          <h2>Why Choose Transwave</h2>
          <p>Built on trust, compliance, and professional logistics expertise across every transport mode.</p>
        </div>
        <div className="row features-card-row">
          {props.data
            ? props.data.map((d, i) => (
                <motion.div
                  key={`${d.title}-${i}`}
                  className="col-xs-12 col-sm-6 col-md-3 features-card-col"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.1 }}
                >
                  <div className="feature-card">
                    <div className="feature-card-icon">
                      <i className={d.icon}></i>
                    </div>
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>
                  </div>
                </motion.div>
              ))
            : "Loading..."}
        </div>
      </div>
    </motion.section>
  );
};
